import React from "react";
import navlinks from "./navlinks";
import sidebarLinks from "./sidebarLinks";
import classes from "./Sidebar.module.css";
import { AiFillCloseCircle } from "react-icons/ai";
import { Link } from "react-router-dom";

const Sidebar = (props) => {
  return (
    <div
      className={`${classes.sidebar} ${
        props.showSideBar ? classes["sidebar-show"] : ""
      }`}
    >
      <span className={classes["main-header-container__close"]}>
        <AiFillCloseCircle onClick={props.onShowSideBar} />
      </span>
      <div className={classes["sidebar__links-container"]}>
        {sidebarLinks.map((link, linkIndex) => {
          const { name, path } = link;
          return (
            <Link key={linkIndex} to={path} onClick={props.onShowSideBar}>
              {name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
